import {Tooltip} from 'bootstrap'

export default {
    mounted(el, binding) {
        new Tooltip(el, {
            title: binding.value || el.getAttribute('title'),
            // options...
        })
    },
    unmounted(el) {
        const tooltip = Tooltip.getInstance(el)
        if (tooltip) {
            tooltip.dispose()
        }
    }
}